"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _style = require("webmotors-react-pj/webinput/radio/style");
var _utils = require("webmotors-react-pj/utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = exports.default = (0, _react.forwardRef)((props, ref) => {
  const {
    checked,
    placeholder,
    onChange,
    dataQaLabel,
    dataQaInput,
    required = false,
    disabled = false
  } = props;
  const [error, setError] = (0, _react.useState)(false);
  const [itemChecked, setItemChecked] = (0, _react.useState)(checked);
  const propsCustom = (0, _utils.customAttributes)(props, 'onChange|type|checked|required');
  const handleChange = e => {
    if (disabled === false) {
      setItemChecked(prevState => !prevState);
      if (required) {
        const items = document.querySelectorAll("[name=".concat(propsCustom === null || propsCustom === void 0 ? void 0 : propsCustom.name, "]"));
        items.forEach(item => {
          item.focus();
          item.blur();
        });
      }
      onChange && onChange(e);
    }
  };
  const handleBlur = () => {
    if (required) {
      const itemsChecked = document.querySelectorAll("[name=".concat(propsCustom.name, "]:checked"));
      if (itemsChecked.length) {
        setError(false);
      } else {
        setError(true);
      }
    }
  };
  return _react.default.createElement(_style.StyleLabel, {
    "data-qa": dataQaLabel || '',
    "data-input-error": error,
    disabled: disabled
  }, _react.default.createElement(_style.StyleInput, (0, _extends2.default)({
    ref: ref,
    "data-qa": dataQaInput || ''
  }, propsCustom, {
    type: "radio",
    defaultChecked: itemChecked,
    onChange: e => handleChange(e),
    onBlur: () => handleBlur(),
    disabled: disabled
  })), _react.default.createElement(_style.StyleSquare, {
    error: error,
    disabled: disabled
  }, _react.default.createElement("svg", {
    xmlns: "https://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18"
  }, _react.default.createElement("path", {
    d: "M12.7,5.3l-5.3,5.3L5.3,8.5c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4l2.8,2.8C6.9,12.9,7.2,13,7.4,13s0.5-0.1,0.7-0.3l6-6 c0.4-0.4,0.4-1,0-1.4C13.7,4.9,13.1,4.9,12.7,5.3z"
  }))), _react.default.createElement(_style.StylePlaceholder, {
    error: error
  }, placeholder));
});